export enum RoutesEnum {
  HOME = "/",
  SOLUTIONS = "/riesenia",
  PROJECTS = "/projekty",
  PROJECT_DETAIL = "/projekty/detail",
  ABOUT = "/o-spolocnosti",
  EU_PROJECTS = "/projekty-eu",
  GDPR = "/gdpr",
  CONTACT = "/kontakt",
  BLOG = "/novinky",
  BLOG_POST = "/novinky/:slug",

  ADMIN = "/admin",
  ADMIN_LOGIN = "/admin/login",
  ADMIN_PROJECTS = "/admin/projekty-eu",
  ADMIN_BLOG = "/admin/novinky",
  ADMIN_BLOG_NEW = "/admin/novinky/novy",
  ADMIN_BLOG_EDIT = "/admin/novinky/:id",

  // partial
  ZELIEZOVCE = "zeliezovce",
  HARMANEC = "harmanec",
  CENOVO = "cenovo",
  CARBOPRAX = "carboprax",
  DRUZBA = "druzba",
  PODBREZOVA = "podbrezova",
  SENEC = "senec",
  PRUSKE = "pruske",
  MONDELEZ = "mondelez",
  FORTISCHEM = "fortischem",
  LISCI_VRCH = "lisci-vrch",
  ORION = "orion",
  ZAMKA = "zamkovskeho-chata",
}

export function buildBlogPostRoute(slug: string): string {
  return RoutesEnum.BLOG_POST.replace(":slug", slug);
}
